module.exports = __webpack_public_path__ + "static/media/cylinder.1d062188.svg";